export default __webpack_public_path__ + "media/siteware_admin/favicon-120-e8491fa82c9799c7942a6f264b823c62.png";